import { JSONSchemaType } from 'ajv'

export interface ICertificateUploadFormData {
  password: string
  digitalCertificate: string
  cnpjConducco: string
  acceptance: boolean
}

const CertificateUploadSchema: JSONSchemaType<ICertificateUploadFormData> = {
  type: 'object',
  properties: {
    password: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Este campo não pode estar em branco',
    },
    digitalCertificate: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Este campo não pode estar em branco',
    },
    acceptance: {
      type: 'boolean',
      errorMessage: 'Você deve aceitar os termos!',
    },
    cnpjConducco: {
      type: 'string',
    },
  },
  required: ['password', 'digitalCertificate', 'acceptance'],
  additionalProperties: false,
}

export default CertificateUploadSchema
